import { render, staticRenderFns } from "./SiteTypoView.vue?vue&type=template&id=2a342ab0&lang=pug"
import script from "./SiteTypoView.vue?vue&type=script&lang=js"
export * from "./SiteTypoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports